import { useCallback } from "react";
import { useIntl } from "react-intl";

import englishMessages from "./lang/en.json";

export type TranslationKey = keyof typeof englishMessages;

export type TranslationValues = Record<string, string | number>;

export type GetLabel = (key: TranslationKey, values?: TranslationValues) => string;

export function isTranslationKey(key: string): key is TranslationKey {
  const isKnownKey = Object.hasOwn(englishMessages, key);

  return isKnownKey;
}

export function useLabel(): GetLabel {
  const intl = useIntl();

  const getLabel = useCallback<GetLabel>((key, values) => intl.formatMessage({ id: key }, values), [intl]);

  return getLabel;
}
